(
    function (skyward, $)
    {
        skyward.bankreconciliation = skyward.bankreconciliation || {};

        var bankReconciliationID;
        var routeModule;

        var init = function (selector)
        {
            bankReconciliationID = $('#BankReconciliationID').val();
            routeModule = $("#RouteModule").val();

            $(selector + " .editablebrowse, " + selector + ".editablebrowse").each(function ()
            {
                var editableBrowse = $(this);
                var data = editableBrowse.data();

                data.editablebrowsedata = data.editablebrowsedata || [];
                
                var closed = $("[name='Closed']").val();

                if (closed && closed.toLowerCase() === 'true')
                {
                    var checkAllCheckbox = editableBrowse.find("[name='MarkAsOnStatement_CheckAll']");
                    if (checkAllCheckbox.length > 0)
                    {
                        checkAllCheckbox.prop("disabled", "disabled");
                    }
                }
            });

            $(selector + " .redirectachtab ").each(function ()
            {
                $(this).click(redirectToACHTab);
            });
            $(selector + " .redirectaccountspayabletab ").each(function ()
            {
                $(this).click(redirectToAccountsPayableTab);
            });
            $(selector + " .redirectjournalentrytab ").each(function ()
            {
                $(this).click(redirectToJournalEntryTab);
            });
            $(selector + " .redirectcashreceiptdeposittab ").each(function ()
            {
                $(this).click(redirectToCashReceiptDepositTab);
            });
            $(selector + " .redirectaccountsreceivabletab ").each(function ()
            {
                $(this).click(redirectToAccountsReceivableTab);
            });
            $(selector + " .redirectcheckstab ").each(function ()
            {
                $(this).click(redirectToChecksTab);
            });
            $(selector + " .redirectwiretransferstab ").each(function ()
            {
                $(this).click(redirectToWireTransfersTab);
            });
            $(selector + " .redirectfeemanagementtab ").each(function ()
            {
                $(this).click(redirectToFeeManagementTab);
            });
            $(selector + " .redirectaccountstab ").each(function ()
            {
                $(this).click(redirectToAccountsTab);
            });
            $(selector + " .redirectadjustmentstab ").each(function ()
            {
                $(this).click(redirectToAdjustmentsTab);
            });
            $(selector + " .redirectfoodservicepaymenttab ").each(function ()
            {
                $(this).click(redirectToFoodServicePaymentTab);
            });
            $(selector + " .redirectfoodservicepurchasedetailtab ").each(function ()
            {
                $(this).click(redirectToFoodServicePurchaseTab);
            });
        };

        var redirectToACHTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabACH" });
        };
        var redirectToAccountsPayableTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabAccountsPayable" });
        };
        var redirectToJournalEntryTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabJournalEntry" });
        };
        var redirectToCashReceiptDepositTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabCashReceiptDeposit" });
        };
        var redirectToAccountsReceivableTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabAccountsReceivable" });
        };
        var redirectToChecksTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabChecks" });
        };
        var redirectToWireTransfersTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabWireTransfers" });
        };
        var redirectToFeeManagementTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabFeeManagement" });
        };
        var redirectToAccountsTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabAccounts" });
        };
        var redirectToAdjustmentsTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabAdjustments" });
        };
        var redirectToFoodServiceTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabFoodServicePayment" });
        };
        var redirectToFoodServiceTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabFoodServicePurchaseDetail" });
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);